const SERVER_DATA = (() => {
  try {
    const fromServer = window.SERVER_DATA ?? {};
    return {
      API_URL: process.env.REACT_APP_API_URL || fromServer.REACT_APP_API_URL,
      API_KEY: process.env.REACT_APP_API_KEY || fromServer.REACT_APP_API_KEY,
      LOGIN_URL: process.env.REACT_APP_LOGIN_URL || fromServer.REACT_APP_LOGIN_URL,
      ENVIRONMENT_NAME:
        process.env.REACT_APP_ENVIRONMENT_NAME || fromServer.REACT_APP_ENVIRONMENT_NAME,
      VERSION: process.env.REACT_APP_VERSION || fromServer.REACT_APP_VERSION,
      POSTHOG_TOKEN: process.env.REACT_APP_POSTHOG_TOKEN || fromServer.REACT_APP_POSTHOG_TOKEN,
      POSTHOG_API_HOST: process.env.REACT_APP_POSTHOG_API_HOST || fromServer.REACT_APP_POSTHOG_API_HOST,
      MAX_RESPONSES_PER_GROUP: process.env.REACT_APP_MAX_RESPONSES_PER_GROUP || fromServer.REACT_APP_MAX_RESPONSES_PER_GROUP,
      DEFAULT_RESPONSES_PER_GROUP: process.env.REACT_APP_DEFAULT_RESPONSES_PER_GROUP || fromServer.REACT_APP_DEFAULT_RESPONSES_PER_GROUP,
    };
  } catch (e) {
    return {};
  }
})();

export const BASE_URL = SERVER_DATA.API_URL || 'https://api.bls-qa.digitalturbine.com/api/';
export const LOGIN_URL = SERVER_DATA.LOGIN_URL || 'https://api.bls-qa.digitalturbine.com/login/';
export const API_KEY = SERVER_DATA.API_KEY || '5b7a5d3e-2fa8-497e-a3e5-8be3ecb8dd05';
export const VERSION = SERVER_DATA.VERSION;
export const REACT_APP_ENVIRONMENT_NAME = SERVER_DATA.ENVIRONMENT_NAME;
export const POSTHOG_TOKEN = SERVER_DATA.POSTHOG_TOKEN;
export const POSTHOG_API_HOST = SERVER_DATA.POSTHOG_API_HOST || 'https://eu.i.posthog.com';
export const isProduction = process.env.NODE_ENV === 'production';
export const MAX_RESPONSES_PER_GROUP = Number(SERVER_DATA.MAX_RESPONSES_PER_GROUP) || 10000;
export const DEFAULT_RESPONSES_PER_GROUP = Number(SERVER_DATA.DEFAULT_RESPONSES_PER_GROUP) || 300;